











import vue from "vue";
import { VUEX_EXERCISE_GETTER_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

import ExerciseComponent from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseComponent.vue";

const { BODY, EXERCISE_TYPE } = VUEX_EXERCISE_GETTER_NAMES;

interface Computed {
  exerciseType: number;
  pageBody: any[];
}

interface Props {
  type: string;
}

export default vue.extend<any, any, Computed, Props>({
  name: "ExerciseBody",

  components: {
    ExerciseComponent
  },

  computed: {
    pageBody() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${BODY}`];
    },

    exerciseType() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_TYPE}`];
    }
  }
});
